// import SingleChoice from "./SingleChoice.svg";

export const Email = (iconColor: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.62905 2.16666H9.37094C10.5961 2.16665 11.5665 2.16665 12.326 2.26875C13.1076 2.37384 13.7403 2.59525 14.2392 3.09416C14.7381 3.59307 14.9595 4.2257 15.0646 5.00732C15.1667 5.76679 15.1667 6.73722 15.1667 7.96239V8.03761C15.1667 9.26278 15.1667 10.2332 15.0646 10.9927C14.9595 11.7743 14.7381 12.4069 14.2392 12.9058C13.7403 13.4047 13.1076 13.6262 12.326 13.7312C11.5665 13.8334 10.5961 13.8333 9.37094 13.8333H6.62906C5.40388 13.8333 4.43346 13.8334 3.67398 13.7312C2.89237 13.6262 2.25973 13.4047 1.76082 12.9058C1.26192 12.4069 1.0405 11.7743 0.935418 10.9927C0.833309 10.2332 0.833318 9.26278 0.833328 8.03761V7.96239C0.833318 6.73721 0.833309 5.76679 0.935418 5.00732C1.0405 4.2257 1.26192 3.59307 1.76082 3.09416C2.25973 2.59525 2.89237 2.37384 3.67398 2.26875C4.43346 2.16665 5.40388 2.16665 6.62905 2.16666ZM3.80723 3.25984C3.1365 3.35001 2.75007 3.51913 2.46793 3.80127C2.18579 4.08341 2.01668 4.46984 1.9265 5.14056C1.83439 5.82567 1.83333 6.72878 1.83333 8C1.83333 9.27121 1.83439 10.1743 1.9265 10.8594C2.01668 11.5302 2.18579 11.9166 2.46793 12.1987C2.75007 12.4809 3.1365 12.65 3.80723 12.7402C4.49234 12.8323 5.39545 12.8333 6.66666 12.8333H9.33333C10.6045 12.8333 11.5077 12.8323 12.1928 12.7402C12.8635 12.65 13.2499 12.4809 13.5321 12.1987C13.8142 11.9166 13.9833 11.5302 14.0735 10.8594C14.1656 10.1743 14.1667 9.27121 14.1667 8C14.1667 6.72878 14.1656 5.82567 14.0735 5.14056C13.9833 4.46984 13.8142 4.08341 13.5321 3.80127C13.2499 3.51913 12.8635 3.35001 12.1928 3.25984C11.5077 3.16773 10.6045 3.16666 9.33333 3.16666H6.66666C5.39545 3.16666 4.49234 3.16773 3.80723 3.25984ZM3.61588 5.01324C3.79267 4.8011 4.10795 4.77244 4.32009 4.94922L5.75935 6.14861C6.38132 6.66692 6.81315 7.02561 7.17772 7.26008C7.53062 7.48706 7.76995 7.56325 8 7.56325C8.23004 7.56325 8.46937 7.48706 8.82227 7.26008C9.18684 7.02561 9.61867 6.66692 10.2406 6.14861L11.6799 4.94922C11.892 4.77244 12.2073 4.8011 12.3841 5.01324C12.5609 5.22538 12.5322 5.54066 12.3201 5.71744L10.8558 6.93771C10.2649 7.43015 9.78592 7.82928 9.36321 8.10115C8.92288 8.38435 8.49405 8.56325 8 8.56325C7.50594 8.56325 7.07711 8.38435 6.63678 8.10115C6.21407 7.82928 5.73514 7.43015 5.14424 6.93772L3.6799 5.71744C3.46776 5.54066 3.4391 5.22538 3.61588 5.01324Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const Phone = (iconColor: string) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.00501 2.27124C5.12505 1.15119 7.01515 1.23634 7.79503 2.63375L8.2277 3.40904C8.73698 4.32159 8.51996 5.47297 7.77442 6.22762C7.76449 6.24122 7.71187 6.31785 7.70531 6.45172C7.69695 6.6226 7.75764 7.01779 8.36992 7.63007C8.98201 8.24216 9.37714 8.303 9.54809 8.29468C9.68208 8.28817 9.75876 8.23551 9.77238 8.22557C10.527 7.48004 11.6784 7.26302 12.591 7.77229L13.3662 8.20497C14.7637 8.98485 14.8488 10.8749 13.7288 11.995C13.1297 12.5941 12.333 13.1264 11.3969 13.1619C10.0096 13.2145 7.70613 12.8562 5.42494 10.5751C3.14375 8.29387 2.78549 5.99038 2.83808 4.60309C2.87357 3.66696 3.4059 2.87035 4.00501 2.27124ZM6.92181 3.12108C6.52246 2.40552 5.44933 2.24113 4.71211 2.97835C4.19522 3.49524 3.85917 4.06579 3.83737 4.64097C3.79351 5.79787 4.07913 7.81504 6.13205 9.86795C8.18496 11.9209 10.2021 12.2065 11.359 12.1626C11.9342 12.1408 12.5048 11.8048 13.0217 11.2879C13.7589 10.5507 13.5945 9.47753 12.8789 9.07819L12.1036 8.64551C11.6214 8.37636 10.9439 8.46817 10.4684 8.9437L10.4682 8.94385C10.4215 8.99053 10.1243 9.26784 9.59668 9.2935C9.05653 9.31978 8.40271 9.07708 7.66281 8.33718C6.92268 7.59704 6.68006 6.94304 6.70651 6.40282C6.73235 5.87514 7.00983 5.57807 7.05626 5.53164L7.05628 5.53162C7.53182 5.05607 7.62363 4.37865 7.35448 3.89637L6.92181 3.12108Z"
        fill={iconColor || "#8E8E8E"}
      />
    </svg>
  );
};

export const Calender = (iconColor = "#8E8E8E") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.3334 9.33329C11.7016 9.33329 12 9.03482 12 8.66663C12 8.29844 11.7016 7.99996 11.3334 7.99996C10.9652 7.99996 10.6667 8.29844 10.6667 8.66663C10.6667 9.03482 10.9652 9.33329 11.3334 9.33329Z"
        fill={iconColor}
      />
      <path
        d="M11.3334 12C11.7016 12 12 11.7015 12 11.3333C12 10.9651 11.7016 10.6666 11.3334 10.6666C10.9652 10.6666 10.6667 10.9651 10.6667 11.3333C10.6667 11.7015 10.9652 12 11.3334 12Z"
        fill={iconColor}
      />
      <path
        d="M8.66671 8.66663C8.66671 9.03482 8.36823 9.33329 8.00004 9.33329C7.63185 9.33329 7.33337 9.03482 7.33337 8.66663C7.33337 8.29844 7.63185 7.99996 8.00004 7.99996C8.36823 7.99996 8.66671 8.29844 8.66671 8.66663Z"
        fill={iconColor}
      />
      <path
        d="M8.66671 11.3333C8.66671 11.7015 8.36823 12 8.00004 12C7.63185 12 7.33337 11.7015 7.33337 11.3333C7.33337 10.9651 7.63185 10.6666 8.00004 10.6666C8.36823 10.6666 8.66671 10.9651 8.66671 11.3333Z"
        fill={iconColor}
      />
      <path
        d="M4.66671 9.33329C5.0349 9.33329 5.33337 9.03482 5.33337 8.66663C5.33337 8.29844 5.0349 7.99996 4.66671 7.99996C4.29852 7.99996 4.00004 8.29844 4.00004 8.66663C4.00004 9.03482 4.29852 9.33329 4.66671 9.33329Z"
        fill={iconColor}
      />
      <path
        d="M4.66671 12C5.0349 12 5.33337 11.7015 5.33337 11.3333C5.33337 10.9651 5.0349 10.6666 4.66671 10.6666C4.29852 10.6666 4.00004 10.9651 4.00004 11.3333C4.00004 11.7015 4.29852 12 4.66671 12Z"
        fill={iconColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.66671 1.16663C4.94285 1.16663 5.16671 1.39048 5.16671 1.66663V2.17511C5.60804 2.16662 6.09426 2.16662 6.62901 2.16663H9.37098C9.90575 2.16662 10.392 2.16662 10.8334 2.17511V1.66663C10.8334 1.39048 11.0572 1.16663 11.3334 1.16663C11.6095 1.16663 11.8334 1.39048 11.8334 1.66663V2.21802C12.0067 2.23123 12.1708 2.24784 12.3261 2.26872C13.1077 2.3738 13.7403 2.59521 14.2392 3.09412C14.7381 3.59303 14.9595 4.22566 15.0646 5.00728C15.1667 5.76675 15.1667 6.73716 15.1667 7.96232V9.3709C15.1667 10.5961 15.1667 11.5665 15.0646 12.326C14.9595 13.1076 14.7381 13.7402 14.2392 14.2391C13.7403 14.738 13.1077 14.9595 12.3261 15.0645C11.5666 15.1666 10.5962 15.1666 9.37101 15.1666H6.6291C5.40394 15.1666 4.4335 15.1666 3.67403 15.0645C2.89241 14.9595 2.25978 14.738 1.76087 14.2391C1.26196 13.7402 1.04055 13.1076 0.935464 12.326C0.833355 11.5665 0.833364 10.5961 0.833374 9.3709V7.96235C0.833364 6.73717 0.833355 5.76675 0.935464 5.00728C1.04055 4.22566 1.26196 3.59303 1.76087 3.09412C2.25978 2.59521 2.89241 2.3738 3.67403 2.26872C3.82931 2.24784 3.99341 2.23123 4.16671 2.21802V1.66663C4.16671 1.39048 4.39057 1.16663 4.66671 1.16663ZM3.80727 3.2598C3.13655 3.34998 2.75012 3.51909 2.46798 3.80123C2.18584 4.08337 2.01672 4.4698 1.92655 5.14052C1.91128 5.25412 1.89851 5.3737 1.88783 5.49996H14.1123C14.1016 5.3737 14.0888 5.25412 14.0735 5.14053C13.9834 4.4698 13.8142 4.08337 13.5321 3.80123C13.25 3.51909 12.8635 3.34998 12.1928 3.2598C11.5077 3.16769 10.6046 3.16663 9.33337 3.16663H6.66671C5.39549 3.16663 4.49238 3.16769 3.80727 3.2598ZM1.83337 7.99996C1.83337 7.43062 1.83359 6.93511 1.8421 6.49996H14.158C14.1665 6.93511 14.1667 7.43062 14.1667 7.99996V9.33329C14.1667 10.6045 14.1656 11.5076 14.0735 12.1927C13.9834 12.8635 13.8142 13.2499 13.5321 13.532C13.25 13.8142 12.8635 13.9833 12.1928 14.0735C11.5077 14.1656 10.6046 14.1666 9.33337 14.1666H6.66671C5.39549 14.1666 4.49238 14.1656 3.80727 14.0735C3.13655 13.9833 2.75012 13.8142 2.46798 13.532C2.18584 13.2499 2.01672 12.8635 1.92655 12.1927C1.83444 11.5076 1.83337 10.6045 1.83337 9.33329V7.99996Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const SingleChoiceSVG = (iconColor = "#B9B9B9") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
        fill={iconColor}
      />
    </svg>
  );
};
export const SingleChoiceSelectedSVG = (iconColor = "#9035FF") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17Z"
        fill={iconColor}
      />
    </svg>
  );
};
export const MultiChoiceSVG = (iconColor = "#B9B9B9") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5Z"
        fill={iconColor}
      />
    </svg>
  );
};
export const MultiChoiceSelectedSVG = (iconColor = "#9035FF") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const CancelButton = (iconColor = "#B9B9B9") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.50513 11.4957L8.00046 8.00034L11.4958 11.4957M11.4958 4.505L7.99979 8.00034L4.50513 4.505"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TaskLogo = ({ primary, secondary, tertiary }: any) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150" fill="none">
      <path d="M112.5 25H37.5C27.1447 25 18.75 33.3947 18.75 43.75V118.75C18.75 129.105 27.1447 137.5 37.5 137.5H112.5C122.855 137.5 131.25 129.105 131.25 118.75V43.75C131.25 33.3947 122.855 25 112.5 25Z" fill={primary || "#BF8AFF"} />
      <path d="M93.75 81.25H56.25C54.5924 81.25 53.0027 80.5915 51.8306 79.4194C50.6585 78.2473 50 76.6576 50 75C50 73.3424 50.6585 71.7527 51.8306 70.5806C53.0027 69.4085 54.5924 68.75 56.25 68.75H93.75C95.4076 68.75 96.9973 69.4085 98.1694 70.5806C99.3415 71.7527 100 73.3424 100 75C100 76.6576 99.3415 78.2473 98.1694 79.4194C96.9973 80.5915 95.4076 81.25 93.75 81.25ZM93.75 106.25H56.25C54.5924 106.25 53.0027 105.592 51.8306 104.419C50.6585 103.247 50 101.658 50 100C50 98.3424 50.6585 96.7527 51.8306 95.5806C53.0027 94.4085 54.5924 93.75 56.25 93.75H93.75C95.4076 93.75 96.9973 94.4085 98.1694 95.5806C99.3415 96.7527 100 98.3424 100 100C100 101.658 99.3415 103.247 98.1694 104.419C96.9973 105.592 95.4076 106.25 93.75 106.25Z" fill={"white"} />
      <path d="M87.5 12.5H62.5C57.5272 12.5 52.7581 14.4754 49.2417 17.9917C45.7254 21.5081 43.75 26.2772 43.75 31.25C43.75 36.2228 45.7254 40.9919 49.2417 44.5083C52.7581 48.0246 57.5272 50 62.5 50H87.5C92.4728 50 97.2419 48.0246 100.758 44.5083C104.275 40.9919 106.25 36.2228 106.25 31.25C106.25 26.2772 104.275 21.5081 100.758 17.9917C97.2419 14.4754 92.4728 12.5 87.5 12.5Z" fill={tertiary || "#6525B3"} />
    </svg>
  )
}